import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-loading-device",
  templateUrl: "./loading_device.html",
  styleUrls: ["./loading_device.scss"]
})
export class LoagingDeviceComponent implements OnInit {
  @Input() menu = null;
  @Input() device = null;
  constructor() {}

  ngOnInit(): void {}
}
